<template>
    <div v-loading="loading">
        <globalhead></globalhead>
        <div class="container-bg">
            <!-- include: common/header -->

            <div class="brand-menu" style="text-align: left;" v-if="keyword">
                <div class="brand-menu-text">
                    <a href="/">首页</a>
                    <img src="../assets/picture/list_btn_more@2x.png" /> 关于"{{ keyword }}"的搜索结果
                </div>
            </div>

            <div class="list-nav J_list_nav J_emptyGood">
                <!-- if(categorys) -->

                <div class="list-nav-li" v-if="categoryList">
                    <div class="list-nav-li-head">类别：</div>
                    <div :class="!cateMore ? 'in-ul-more' : 'in-ul'">
                        <div id="cate-fold" class="in-ul">
                            <div v-for="(item, key) in categoryList" :key="key">
                                <div class="categoryTitle">
                                    <template>
                                        <a
                                            v-if="categoryID == item.CategoryID"
                                            :style="{ color: '#F03A58' }"
                                            :href="'search?CategoryID=' + item.CategoryID"
                                            :title="item.Name"
                                            >{{ item.Name }}</a
                                        >
                                        <a v-else :href="'search?CategoryID=' + item.CategoryID" :title="item.Name">{{ item.Name }}</a>
                                    </template>
                                </div>
                                <ul style="width: calc(100% - 65px)">
                                    <li class="J_lb" v-for="(subItem, subKey) in item.SubsetList" :key="subKey">
                                        <template>
                                            <a
                                                v-if="categoryID == subItem.CategoryID"
                                                :style="{ color: '#F03A58' }"
                                                :href="'search?CategoryID=' + subItem.CategoryID"
                                                :title="subItem.Name"
                                                >{{ subItem.Name }}</a
                                            >
                                            <a v-else :href="'search?CategoryID=' + subItem.CategoryID" :title="subItem.Name">{{
                                                subItem.Name
                                            }}</a>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="more" @click="cateMore = !cateMore" v-if="cateMoreHeight > 72">
                        {{ !cateMore ? '更多' : '收起' }}
                        <img :src="more_img" alt="" :style="{ transform: !cateMore ? 'rotate(0deg)' : 'rotate(180deg)' }" />
                    </div>
                </div>

                <!-- if (s.brands) -->
                <div class="list-nav-li" :class="!more ? 'ul-list-more' : 'ul-list-no-more'" module="filter-brands" v-if="dataList">
                    <div class="list-nav-li-head">品牌：</div>
                    <ul class="fold">
                        <!-- foreach brands[] -->
                        <li v-for="(item, key) in dataList.Brand" :key="key">
                            <a
                                v-if="brandID == item.BrandID"
                                :style="{ color: '#F03A58' }"
                                :href="'search?' + (categoryID ? 'CategoryID=' + categoryID + '&' : '') + 'BrandID=' + item.BrandID"
                                :title="item.Name"
                                >{{ item.Name }}</a
                            >
                            <a
                                v-else
                                :href="'search?' + (categoryID ? 'CategoryID=' + categoryID + '&' : '') + 'BrandID=' + item.BrandID"
                                :title="item.Name"
                                >{{ item.Name }}</a
                            >
                        </li>
                    </ul>
                    <div class="more" @click="more = !more" v-if="more_height > 72">
                        {{ !more ? '更多' : '收起' }}
                        <img :src="more_img" alt="" :style="{ transform: !more ? 'rotate(0deg)' : 'rotate(180deg)' }" />
                    </div>
                </div>

                <div class="list-nav-li">
                    <div class="list-nav-li-head">筛选：</div>
                    <el-checkbox v-model="isShowQuote" @change="onlyShowQuote" style="height: 36px; line-height: 36px;">
                        只显示已报价商品
                    </el-checkbox>
                </div>

                <div class="clearfix"></div>
                <div class="clearfix"></div>
            </div>

            <!-- 品牌推荐 -->
            <!-- include: common/header -->
            <div class="list-main J_emptyGood">
                <div class="list-main-box J_list J_car_box" id="goodsList" v-if="dataList">
                    <div v-for="(item, key) in dataList.SkuInfo.Data" :key="key">
                        <div class="goods-items goods-items-border">
                            <div class="J_bigImage goods-image">
                                <a :href="'ProcInfo?sku=' + item.SKU" target="_blank">
                                    <img
                                        :src="'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=90&name=' + item.PicName + '&type=1'"
                                        :alt="item.Name"
                                        class="J_flyImg"
                                    />
                                </a>
                            </div>
                            <div class="tip J_bigImage_show"></div>
                            <div class="goods-info" style="text-align: left;padding-top: 20px; font-size: 16px;">
                                <a :href="'ProcInfo?sku=' + item.SKU" target="_blank" :title="item.Name" class="goods-name">
                                    <span>{{ item.Name }}</span>
                                </a>
                            </div>
                            <div class="goods-price">
                                <template v-if="item.IsCustProduct">
                                    <div class="present-price">￥{{ (item.Price / 100).toFixed(2) }}</div>
                                    <div class="original-price" v-if="item.Price != item.StandPrice">
                                        ￥{{ (item.StandPrice / 100).toFixed(2) }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="present-price">￥????</div>
                                </template>

                                <div class="activity"></div>
                            </div>

                            <div
                                class="goods-right-order"
                                data-handle
                                data-sid="1507558"
                                data-least="1"
                                data-batch="1"
                                style="width: auto;text-align: right;float: right;"
                            >
                                >
                                <div class="J_minNum un-select ft24" @click="minus(item)">-</div>
                                <input type="text" class="detail-goods-right-text ft16 J_goodNum" v-model="item.Count" />
                                <div class="J_addNum un-select ft24" @click="plus(item)">+</div>
                                <span class="unbind"></span>
                                <a v-if="item.IsCustProduct" href="javascript:void 0;" class="goods-order" @click="subscribe(item)">订购</a>
                                <a
                                    v-else
                                    href="javascript:void 0;"
                                    class="goods-order"
                                    style="width: 90px;"
                                    @click="AddInquiryOrder(item.SKUID)"
                                    >加入询价单</a
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="m-pagination noselect">
                    <el-pagination
                        background
                        :page-size="pageSize"
                        :pager-count="11"
                        layout="prev, pager, next"
                        :total="pageTotal"
                        @current-change="drop($event)"
                    >
                    </el-pagination>
                </div>
                <!-- 分页/END -->
            </div>
        </div>
        <globalfoot></globalfoot>
    </div>
</template>

<script>
// @ is an alias to /src
import globalhead from '@/components/Global-Head';
import globalfoot from '@/components/Global-Foot';
import { GlobalFun } from '@/common/utils';
import { ShopCartApi, GetProductSKUListInPortal, GetCategoryList, QuickInquiry, InquiryOrderApi } from '../common/api';
import $ from 'jquery';

export default {
    data() {
        return {
            keyword: '',
            brandID: '',
            categoryID: '',
            dataList: null,
            byNum: 1,
            loading: false,
            isHasParams: false, //地址栏是否存在其他关键字

            //分页信息
            pageSize: 20,
            pageIndex: 0,
            pageCount: 11,
            innerPageCount: 1,
            pageTotal: 0,

            //一级二级分类
            categoryList: [],

            //品牌展开
            more: false,
            more_img: require('@/assets/images/select_sub.png'),
            more_height: 0,

            cateMore: false,
            cateMoreHeight: 0,
            isShowQuote: false
        };
    },
    methods: {
        /**
         * 只显示报价商品
         */
        onlyShowQuote() {
            this.search();
        },
        //加入购物车
        async subscribe(item) {
            ShopCartApi.AddToShoppingCart(item.SKUID, item.Count).then(res => {
                this.$message({
                    message: '加入购物车成功！',
                    type: 'success'
                });
            });
        },
        async search(e) {
            this.dataList = await this.getSearchData();
            if (this.dataList) {
                this.$forceUpdate();
            }
            this.keyword = e;
        },
        async drop(e) {
            this.loading = true;
            this.pageIndex = e - 1;
            let data = await this.getSearchData();
            this.dataList.SkuInfo = data.SkuInfo;
            this.dataList.SkuInfo.Data.splice(data.SkuInfo.Data.length, 0);
            this.loading = false;
            console.log(this.dataList.SkuInfo.Data[19].PicName);
        },
        getSearchData() {
            return new Promise(result => {
                let data = {
                    pageSize: this.pageSize,
                    pageIndex: this.pageIndex,
                    BrandID: this.brandID ? this.brandID : '',
                    KeyWord: this.keyword,
                    CategoryID: this.categoryID ? this.categoryID : '',
                    IsCustProduct: this.isShowQuote
                };
                this.loading = true;
                GetProductSKUListInPortal(data)
                    .then(res => {
                        for (let item of res.SkuInfo.Data) {
                            item.Count = 1;
                        }
                        this.pageTotal = res.SkuInfo.TotalCount;
                        this.pageCount = Math.ceil(this.pageTotal / this.pageSize);
                        // this.innerPageCount = Math.ceil(this.pageTotal / this.pageCount);
                        result(res);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },
        minus(item) {
            if (item.Count <= 1) {
                this.$message({
                    message: '采购数不能小于1',
                    type: 'info'
                });
                return;
            }
            --item.Count;
        },
        plus(item) {
            ++item.Count;
        },
        getUrlKey: function(name) {
            return (
                decodeURIComponent(
                    (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')
                ) || null
            );
        },
        AddInquiryOrder(skuid) {
            this.loading = true;
            InquiryOrderApi.AddToInquirySheet(skuid)
                .then(() => {
                    this.$message({
                        message: '加入成功',
                        type: 'success'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        QuickInquiry(skuid) {
            this.loading = true;
            QuickInquiry(skuid)
                .then(res => {
                    this.$message({
                        message: '询价成功',
                        type: 'success'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    async mounted() {
        this.loading = true;
        //获取分类列表
        this.categoryList = await GetCategoryList();
        //获取地址栏里面的参数
        this.brandID = this.getUrlKey('BrandID');
        this.categoryID = this.getUrlKey('CategoryID');
        //查找点击的分类是不是第一个，不是的话直接展开
        for (let i = 0, ilen = this.categoryList.length; i < ilen; i++) {
            for (let j = 0, jlen = this.categoryList[i].SubsetList.length; j < jlen; j++) {
                if (this.categoryList[i].SubsetList[j].CategoryID == this.categoryID) {
                    if (i != 0) {
                        this.cateMore = true;
                    }
                    break;
                }
            }
        }
        this.keyword = this.getUrlKey('keyword');
        //获取商品
        this.dataList = await this.getSearchData();

        this.loading = false;
    },
    updated() {
        //计算品牌是否超过两行
        this.more_height = $('.fold').height();
        this.cateMoreHeight = $('#cate-fold').height();
    },
    components: {
        globalhead,
        globalfoot
    }
};
</script>

<style>
.in-ul-more {
    width: 980px;
    float: left;
    height: 72px;
    overflow: hidden;
}
.in-ul {
    height: auto;
    width: 980px;
    float: left;
}
.categoryTitle {
    float: left;
    text-align: left;
    width: 65px;
    height: 36px;
    line-height: 36px;
    color: black;
}
.categoryTitle a {
    color: black;
}
.ul-list-more {
    height: 72px;
    overflow: hidden;
}
.ul-list-no-more {
    height: auto;
}
.more {
    width: 63px;
    border: 1px solid #ebebeb;
    height: 26px;
    line-height: 26px;
    margin-top: 5px;
    text-align: center;
    float: left;
    color: #666666;
    cursor: pointer;
}
.home {
    display: flex;
    flex-direction: column;
}

.disabled {
    cursor: not-allowed;
}

.noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Chrome/Safari/Opera */
    -khtml-user-select: none;
    /* Konqueror */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #fff;
    background-color: #f03a58;
}

.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #fff;
    background-color: #f03a58;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: red;
}
</style>
